import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const PrecertificacionReducer = createReducer(
  INITIAL_STATE,
  (builder) => {
    /**
     * Obtener datos de una precertificacion
     */
    builder
      .addCase(Types.GET_PRECERTIFICACION_LOADING, (state) => {
        state.getPrecertificacionLoading = true;
        state.getPrecertificacionError = null;
      })
      .addCase(Types.GET_PRECERTIFICACION_SUCCESS, (state, action) => {
        const { getPrecertificacionData } = action;
        state.getPrecertificacionData = getPrecertificacionData;
        state.getPrecertificacionLoading = false;
        state.getPrecertificacionError = null;
      })
      .addCase(Types.GET_PRECERTIFICACION_FAILURE, (state, action) => {
        const { getPrecertificacionError } = action;
        state.getPrecertificacionData = INITIAL_STATE.getPrecertificacionData;
        state.getPrecertificacionLoading = false;
        state.getPrecertificacionError = getPrecertificacionError;
      });

    /**
     * Confirmar una precertificacion
     */
    builder
      .addCase(Types.CONFIRMAR_PRECERTIFICACION_LOADING, (state) => {
        state.confirmarPrecertificacionLoading = true;
        state.confirmarPrecertificacionError = null;
      })
      .addCase(Types.CONFIRMAR_PRECERTIFICACION_SUCCESS, (state, action) => {
        const { confirmarPrecertificacionData } = action;
        state.confirmarPrecertificacionData = confirmarPrecertificacionData;
        state.confirmarPrecertificacionLoading = false;
        state.confirmarPrecertificacionError = null;
      })
      .addCase(Types.CONFIRMAR_PRECERTIFICACION_FAILURE, (state, action) => {
        const { confirmarPrecertificacionError } = action;
        state.confirmarPrecertificacionData =
          INITIAL_STATE.confirmarPrecertificacionData;
        state.confirmarPrecertificacionLoading = false;
        state.confirmarPrecertificacionError = confirmarPrecertificacionError;
      });

    /**
     * Cancelar una precertificacion
     */
    builder
      .addCase(Types.CANCELAR_PRECERTIFICACION_LOADING, (state) => {
        state.cancelarPrecertificacionLoading = true;
        state.cancelarPrecertificacionError = null;
      })
      .addCase(Types.CANCELAR_PRECERTIFICACION_SUCCESS, (state, action) => {
        const { cancelarPrecertificacionData } = action;
        state.cancelarPrecertificacionData = cancelarPrecertificacionData;
        state.cancelarPrecertificacionLoading = false;
        state.cancelarPrecertificacionError = null;
      })
      .addCase(Types.CANCELAR_PRECERTIFICACION_FAILURE, (state, action) => {
        const { cancelarPrecertificacionError } = action;
        state.cancelarPrecertificacionData =
          INITIAL_STATE.cancelarPrecertificacionData;
        state.cancelarPrecertificacionLoading = false;
        state.cancelarPrecertificacionError = cancelarPrecertificacionError;
      });
  }
);
